export default "__VITE_ASSET__Cn9nE0xi__"